<template>
    <a-card a-card title="New Sites" class="Custom--Card" :loading="loading">
      <template slot="extra">
        <a-select v-model="selected" @change="newSitesList">
          <a-select-option value="last-30-days">Last 30 Days</a-select-option>
          <a-select-option value="last-month">Last Month</a-select-option>
          <a-select-option value="last-7-days">Last 7 Days</a-select-option>
        </a-select>
        <a-divider type="vertical" />
        <a-button type="default" shape="circle" icon="sync" size="small" @click="newSitesList('refresh')"/>
      </template>
        <div v-if="newSites" >
          <BarChart :chartdata="newSites" :options="options" :styles="style"></BarChart>
        </div>
      </a-card>
</template>
<script>
import BarChart from '@/components/Graphs/BarChart.vue'
import {mapGetters} from "vuex";

export default {
  components: { BarChart },
  data: function (){
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
          }]
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'top'
          }
        }
      },
      loading: true,
      selected: 'last-30-days',
      refresh: false,
      style: {
        width: "100%",
        height: "300px"
      }
    }
  },
  methods: {
    newSitesList (query) {
      this.loading = true;

      let refresh = false;

      if (query === 'refresh') {
        refresh = true;
      } else {
        this.selected = query;
      }

      this.$store.dispatch("dashboard/getNewSites", {query: this.selected, refresh: refresh}).then(() => this.loading = false );
    }
  },
  created() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch("dashboard/getNewSites", this.selected),
    ]).then(() =>  this.loading = false);
  },
  computed: {
    ...mapGetters({
      newSites: "dashboard/getNewSites",
    })
  }
}
</script>